/**
 * Responsive CSS styles for the survey widget.
 * Adjusts max-height of scrollable areas (answer options, matrix, rating)
 * based on viewport height breakpoints.
 */
export const responsiveCSS = `
    /* ===== Very small screens (max-height: 500px) ===== */
    @media (max-height: 500px) {
        .ph-survey--auto-height .ph-options {
            max-height: 35vh;
            overflow-y: auto;
            width: 100%;
        }
        .ph-survey--auto-height .ph-matrix {
            max-height: 35vh;
            overflow-y: auto;
        }
        .ph-survey--auto-height .ph-rating--large {
            max-height: 35vh;
            overflow-y: auto;
        }
    }

    /* ===== Small screens (601px - 700px) ===== */
    @media (min-height: 501px) and (max-height: 700px) {
        .ph-survey--auto-height .ph-options {
            max-height: 50vh;
            overflow-y: auto;
            width: 100%;
        }
        .ph-survey--auto-height .ph-matrix {
            max-height: 50vh;
            overflow-y: auto;
        }
        .ph-survey--auto-height .ph-rating--large {
            max-height: 50vh;
            overflow-y: auto;
        }
    }

    /* ===== Medium screens (701px - 800px) ===== */
    @media (min-height: 701px) and (max-height: 800px) {
        .ph-survey--auto-height .ph-options {
            max-height: 60vh;
            overflow-y: auto;
            width: 100%;
        }
        .ph-survey--auto-height .ph-matrix {
            max-height: 60vh;
            overflow-y: auto;
        }
        .ph-survey--auto-height .ph-rating--large {
            max-height: 60vh;
            overflow-y: auto;
        }
    }

    /* ===== Medium-large screens (801px - 920px) ===== */
    @media (min-height: 801px) and (max-height: 920px) {
        .ph-survey--auto-height .ph-options {
            max-height: 60vh;
            overflow-y: auto;
            width: 100%;
        }
        .ph-survey--auto-height .ph-matrix {
            max-height: 60vh;
            overflow-y: auto;
        }
        .ph-survey--auto-height .ph-rating--large {
            max-height: 60vh;
            overflow-y: auto;
        }
    }

    /* ===== Large screens (920px+) ===== */
    @media (min-height: 920px) {
        .ph-survey--auto-height .ph-options {
            max-height: 370px;
            overflow-y: auto;
            width: 100%;
        }
        .ph-survey--auto-height .ph-matrix {
            max-height: 370px;
            overflow-y: auto;
        }
        .ph-survey--auto-height .ph-rating--large {
            max-height: 370px;
            overflow-y: auto;
        }
    }
`;
